import React, { useCallback } from 'react';
import { ConfigurationSwitch } from '@ydistri/ds';
import { rtkQueryPatchStatusToConfigurationFieldStatus } from '@ydistri/utils';
import {
  UpdateSkuClassConfigurationPayload,
  useUpdateSkuClassConfigurationMutation,
} from './apiSkuClasses';
import { useTemplateOrCalculation } from '../../../hooks/useTemplateOrCalculation';
import { SkuClassConfigurationRequest } from '@ydistri/api-sdk';
import useIsConfigurationEditable from '../../../hooks/useIsConfigurationEditable';

interface SkuClassConfigurationSwitchProps {
  value: boolean;
  skuClassId: number;
  field: keyof SkuClassConfigurationRequest;
}

const SkuClassConfigurationSwitch: React.FC<SkuClassConfigurationSwitchProps> = ({
  value,
  skuClassId,
  field,
}) => {
  const templateOrCalculation = useTemplateOrCalculation();
  const isConfigurationEditable = useIsConfigurationEditable();
  const [updateConfiguration, updateConfigurationStatus] = useUpdateSkuClassConfigurationMutation();

  const onChangeHandler = useCallback(() => {
    const updatePayload: UpdateSkuClassConfigurationPayload = {
      templateOrCalculation,
      skuClassId,
      request: {
        [field]: !value,
      },
    };
    updateConfiguration(updatePayload);
  }, [templateOrCalculation, skuClassId, field, value, updateConfiguration]);

  return (
    <ConfigurationSwitch
      disabled={!isConfigurationEditable}
      status={rtkQueryPatchStatusToConfigurationFieldStatus(updateConfigurationStatus)}
      value={value}
      onChange={onChangeHandler}
      includeEmptySpace={false}
    />
  );
};

export default SkuClassConfigurationSwitch;
